import React, { BaseSyntheticEvent } from 'react'
import { IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/react'
import { chevronBackOutline } from 'ionicons/icons'
import './HeaderNav.component.css'
import OfflineIndicator from '../offlineIndicator/OfflineIndicator.component'
import { goBack } from '../../utilities/navigation.util'

interface IHeaderNavProps {
  prevOnClick?: (e: BaseSyntheticEvent) => void
  prevLabel?: string
  isBackButton?: boolean
  nextOnClick?: (e: BaseSyntheticEvent) => void
  nextLabel?: string
  title: string
  nextIcon?: string
  showOfflineIndicator?: boolean
}

const HeaderNav: React.FC<IHeaderNavProps> = (props: IHeaderNavProps) => {
  const { prevOnClick, prevLabel, isBackButton, nextOnClick, nextLabel, title, nextIcon, showOfflineIndicator } = props

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    goBack()
  }

  const renderBackButton = (): JSX.Element | null => {
    if (isBackButton) {
      return (
        <IonButton color='primary-alt' onClick={prevOnClick ? prevOnClick : onBackClick}>
          <IonIcon icon={chevronBackOutline} />
          {prevLabel}
        </IonButton>
      )
    } else if (prevOnClick) {
      return (
        <IonButton color='primary-alt' onClick={prevOnClick}>
          {prevLabel}
        </IonButton>
      )
    }
    return null
  }

  return (
    <IonHeader>
      <IonToolbar color='light'>
        <IonButtons slot='start'>{renderBackButton()}</IonButtons>
        {nextLabel && (
          <IonButtons slot='end'>
            {showOfflineIndicator && <OfflineIndicator />}
            <IonButton
              color='primary-alt'
              data-testid='Next'
              className={nextIcon && 'show-button'}
              onClick={nextOnClick}>
              {nextLabel}
            </IonButton>
            {nextIcon && (
              <IonButton color='primary-alt' className='show-icon' onClick={nextOnClick}>
                <IonIcon icon={nextIcon} />
              </IonButton>
            )}
          </IonButtons>
        )}
        <IonTitle data-testid='HeaderTitle'>{title}</IonTitle>
      </IonToolbar>
    </IonHeader>
  )
}

export default HeaderNav
